import React from "react";
import ExplainCUFeatures from "./svg_widgets/ExplainCUFeatures";
import ExplainUCFeatures from "./svg_widgets/ExplainUCFeatures";
import ExplainPRO3Features from "./svg_widgets/ExplainPRO3Features";

const ExplainFeaturesSvg = props => {

  const formatNumberValue = (value) => {
    // Convert Indian number format (1,00,000) to US format (100,000)
    const convertIndianToUSFormat = (value) => {
      if (!value || typeof value !== 'string') return value;
      
      // Remove all commas first
      const numberWithoutCommas = value.replace(/,/g, '');
      
      // Check if it's a valid number
      if (isNaN(numberWithoutCommas)) {
        return value;
      }
      
      // Convert to number and back to string with US formatting
      const number = parseFloat(numberWithoutCommas);

      // Format with US comma separation (every 3 digits)
      const result = number.toLocaleString('en-US');    
      return result;
    };
    
    // Actually use the conversion function
    return convertIndianToUSFormat(value);
  };

  if (
    props.type == "HCU" ||
    props.type == "VCU" ||
    props.type == "DVCU" ||
    props.type == "VCU_DVCU" ||
    props.type == "HTS"
  )
    {
      return <ExplainCUFeatures {...props} formatNumberValue={formatNumberValue}></ExplainCUFeatures>;
    }
  else if (
    props.type == "LOP" ||
    props.type == "CM" ||
    props.type == "LVCM" ||
    props.type == "LUC" ||
    props.type == "MP"
  ) {
    return <ExplainUCFeatures {...props} formatNumberValue={formatNumberValue}></ExplainUCFeatures>;
  } else if (
    props.type == "PRO3"
  )
  {
    if(typeof props.modelnumber != "undefined" && props.modelnumber !== "Call Factory")
    {
      return <ExplainPRO3Features {...props} formatNumberValue={formatNumberValue}></ExplainPRO3Features>;
    }
    else
    {
      return <div></div>
    }
    
  }
    
  else return <div>Error: Failed to decode type</div>;
};

export default ExplainFeaturesSvg;
